/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const SubscribeGetNotifications = /* GraphQL */ `
  subscription SubscribeGetNotifications($user_id: String!) {
    SubscribeGetNotifications(user_id: $user_id) {
      items {
        notification_type
        user_id
        created_on
        notification_id
        notification_message
        notification_by
        licence_plate_number
        notified_by_user_name
        __typename
      }
      lastEvaluatedKey
      user_id
      __typename
    }
  }
`;
export const ReceiveMessage = /* GraphQL */ `
  subscription ReceiveMessage($chat_id: String!) {
    ReceiveMessage(chat_id: $chat_id) {
      chat_id
      message_text
      messaged_by_id
      messaged_by_user_details
      message_id
      messaged_on
      message_type
      message_sent_type
      has_reply_message
      no_of_replies
      replied_to_message_id
      replied_for_message_type
      replied_for_message_text
      reactions {
        chat_id
        reaction_id
        message_id
        reacted_time
        reacted_by_user_id
        reacted_by_user_first_name
        reacted_by_user_last_name
        reaction_type
        __typename
      }
      __typename
    }
  }
`;
export const ReceiveVideoCall = /* GraphQL */ `
  subscription ReceiveVideoCall($chat_id: String!) {
    ReceiveVideoCall(chat_id: $chat_id) {
      chat_id
      video_status
      __typename
    }
  }
`;
